var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-skeleton-loading"},[_c('div',{staticClass:"skeleton-bac-animation"}),_vm._v(" "),_c('div',{staticClass:"skeleton-bac-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }